import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '@app-masters/react-lib';

class LetterView extends Component {
    showGreeting (user) {
        const treatmentPronoun = (user.data.gender.toLowerCase() === 'masculino') ? 'Caro' : 'Cara';
        return treatmentPronoun + ' ' + user.name + ',';
    };

    render () {
        const push = this.props.interaction.options[0];
        return (
            <div className='view-background letter interaction' onClick={() => this.props.action(push.value)}>
                <div className='content'>
                    <div className='title'>
                        {this.showGreeting(this.props.user)}
                    </div>
                    <div>
                        {Text.nl2br(this.props.interaction.content.message)}
                    </div>
                </div>
                <div className='from'>
                    {this.props.interaction.from}
                </div>
            </div>
        );
    }
};

const mapStateToProps = ({user}) => ({
    user: user.user
});

export default connect(mapStateToProps)(LetterView);



// WEBPACK FOOTER //
// ./src/views/InteractionViews/letterView.js